import { useCallback } from 'react';
import { useClockDrift } from './useClockDrift';

/**
 * @returns timestamp in milliseconds, like Date.now().
 */
type GetTime = () => number;

/**
 * Call this getTime() instead of Date.now() to factor in clock drift with our server.
 * @returns function to get current time, like Date.now().
 */
export const useGetTime = (): GetTime => {
  const clockDrift = useClockDrift();

  return useCallback(() => {
    return Date.now() - clockDrift;
  }, [clockDrift]);
};
